import React, { memo } from 'react';
import cn from 'classnames';

var styles = {"bar":"stepped-progress-bar__bar_yqsz1","positive":"stepped-progress-bar__positive_yqsz1","attention":"stepped-progress-bar__attention_yqsz1","negative":"stepped-progress-bar__negative_yqsz1","link":"stepped-progress-bar__link_yqsz1","tertiary":"stepped-progress-bar__tertiary_yqsz1","secondary":"stepped-progress-bar__secondary_yqsz1","primary":"stepped-progress-bar__primary_yqsz1","accent":"stepped-progress-bar__accent_yqsz1"};
require('./index.css')

var StepBar = memo(function (_a) {
    var isDone = _a.isDone, _b = _a.view, view = _b === void 0 ? 'positive' : _b, classNameStep = _a.classNameStep;
    return (React.createElement("span", { "data-test-id": isDone ? 'on' : 'off', className: cn(styles.bar, isDone && styles[view], classNameStep) }));
});

export { StepBar };
